









import { ciHamburger } from '~/icons/source/solid/hamburger'
import { mapGetters, mapActions } from 'vuex'
import { DEALER_SITE_LAYOUT_NS } from '~/store/modules/shared/dealers/site/layout/state'
import { DEALER_SITE_NS } from '~/store/modules/shared/dealers/site/state'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  computed: {
    ...mapGetters(DEALER_SITE_NS, ['getTemplateOption']),
    icons: () => ({
      ciHamburger
    })
  },
  methods: {
    ...mapActions(DEALER_SITE_LAYOUT_NS, ['toggleNav'])
  }
})
